import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ExploreModeOutputComponent } from './components/explore-mode-output/explore-mode-output.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,ExploreModeOutputComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'dexcat';
}
